import { Injectable } from '@angular/core';
import { GET, IRestFunc, Rest, RestResource } from '../../../http/RestResource';
import { InjectionBundle } from '../../../http/InjectionBundle';
import { MatchTenantParams } from '../../../tenancy/util/tenant-params';
import { TenantService } from '../../../tenancy/service/tenant.service';
import { AuthenticationService } from '../../../authentication/service/authentication.service';
import { ImageListResponse } from '../types/ws-select-image';

@Injectable()
@Rest({
	name: 'ImageSelect',
	pathPrefix: '/api/v1/admin/files',
})
export class ImageSelectResource extends InjectionBundle {
	@RestResource({
		method: GET,
		path: '/',
	})
	get!: IRestFunc<ImageListResponse>;

	constructor(authentication: AuthenticationService, tenantService: TenantService) {
		super(authentication, tenantService);
	}
}
